import { FailResponse } from 'api/evisaAPI/dlAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {} & Status

const initialState: State = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SKIP_ITOI_INSURANCE_ASYNC,
    Actions.SKIP_ITOI_INSURANCE_SUCCESS,
    Actions.SKIP_ITOI_INSURANCE_FAIL,
    {},
    FailResponse
  >,
) => {
  switch (action.type) {
    case Actions.SKIP_ITOI_INSURANCE_ASYNC:
    case Actions.SKIP_ITOI_INSURANCE_FAIL:
    case Actions.SKIP_ITOI_INSURANCE_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }

    default:
      return state
  }
}
